// 🔧 src/utils/date_format.js
// ✅ Purpose: Utility to format ISO strings to "MM/DD @ h:mma" for volunteer time slot display

export const toDateTime = (value) => {
  if (value?.toDate instanceof Function) {
    return value.toDate();
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value?.seconds === "number") {
    return new Date(
      value.seconds * 1000 + Number(value.nanoseconds || 0) / 1000000
    );
  }

  return new Date(value);
};

export const formatDateTime = (value) => {
  const date = toDateTime(value);

  if (Number.isNaN(date.getTime())) {
    return "Date unavailable";
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date).replace(",", " @");
};
